module.exports = __webpack_public_path__ + "static/img/texun777.a5a6f49.png";